import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { AdvisorKeys } from "web_myplann/Api/Advisor/AdvisorKeys";
import { assignedAgentsQueryOptions } from "web_myplann/Api/Advisor/assignedAgentsQueryOptions";
import {
	getAgentIdV2,
	UserAgentStatusEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import { useOpenAgentChat } from "web_myplann/Shared/Hooks/useOpenAgentChat";
import { getAgentChatTitle } from "web_myplann/Shared/Utils/getAgentChatTitle";

export const useContactAdvisor = () => {
	const queryClient = useQueryClient();
	const openAgentChat = useOpenAgentChat();

	const openChat = useCallback(
		async (message?: string) => {
			const assigned = await queryClient
				.ensureQueryData(
					assignedAgentsQueryOptions(UserAgentStatusEnum.Connected),
				)
				.catch(() => undefined);

			const advisorId = assigned?.data?.[0]?.id;
			if (!advisorId) return;

			const agent = await queryClient
				.ensureQueryData({
					queryKey: AdvisorKeys.agentDetail(advisorId),
					queryFn: processResponse(() => getAgentIdV2(advisorId)),
				})
				.catch(() => undefined);

			openAgentChat({
				uid: agent?.uid,
				title: getAgentChatTitle(agent),
				conversationId: agent?.conversationId,
				message,
			});
		},
		[queryClient, openAgentChat],
	);

	return { openChat };
};
